export default class mobileMenu {
	constructor() {
        this.header = document.querySelector('.site-header')
        this.mobile_menu = document.querySelector('#mobile-menu')
        this.active_tertiary_menu_class = '--active-tertiary'
        this.burger = document.querySelector('#mobile-menu-toggle')
        this.mobile_search_bar = this.mobile_menu.querySelector('.mobile-menu__search')
        this.top_level_items = this.mobile_menu.querySelectorAll('.mobile-menu__item')
		this.active_class = '--is-active'
        this.burger_class = 'is-active'

        this.reset_tertiaries = this.mobile_menu.querySelectorAll('.reset-tertiary-menus')

        this.secondary_menus = document.querySelectorAll('.mobile-sub-menu__secondary')
		this.tertiary_menus = document.querySelectorAll('.mobile-sub-menu__tertiary')

		this.init()
	}

	init() {
        // Add all necessary functions on first load
		this.addBurgerClickEvents()
        this.addSearchClickEvents()
        this.addSecondaryMenuClickEvents()
        this.addTertiaryMenuEvents()
	}

    addBurgerClickEvents() {
        if (this.burger) {
            this.burger.addEventListener('click', (e) => {
                this.toggleBurgerClass()
                this.toggleMobileMenuClass()
                this.setMobileMenuHeight()
            })
        }
    }

    addSearchClickEvents() {
        if (this.mobile_search_bar) {
            this.mobile_search_bar.querySelector('.run-search').addEventListener('click', (e) => {
                e.preventDefault()
                const form = this.mobile_search_bar.querySelector('form')
                const input = form ? form.querySelector('.search-field, input[name="s"]') : null
                if (!input || input.value.trim() === '') {
                    if (input) {
                        input.focus()
                    }
                    return
                }
                form.submit()
            })
        }
    }

    // Adding all click events associated with secondary menu items.
    addSecondaryMenuClickEvents() {
        if (this.top_level_items) {
            this.top_level_items.forEach(top_level_item => {
                const arrow = top_level_item.querySelector('.mobile-menu__item-icon')

                if (arrow) {
                    arrow.addEventListener('click', (e) => {
                        top_level_item.classList.toggle(this.active_class)
                        arrow.classList.toggle(this.active_class)
                    })
                }
            })
        }
    }

	addTertiaryMenuEvents() {
        const elements_with_tertiary_target = this.mobile_menu.querySelectorAll('[data-mobile-tertiary-target]')

        // Adding classes to Tertiary menus and mobile menu container if their respective arrow is clicked
        elements_with_tertiary_target.forEach(el => {
            el.addEventListener('click', (e) => {
                const tertiary_target = document.querySelector(el.dataset.mobileTertiaryTarget)

                if (tertiary_target) {
                    this.mobile_menu.classList.add(this.active_tertiary_menu_class)
                    tertiary_target.classList.add(this.active_class)
                }
            })
        })

        this.reset_tertiaries.forEach(el => {
            el.addEventListener('click', (e) => {
                this.resetTertiaryMenus()
            })
        })
	}

    toggleBurgerClass() {
        this.burger.classList.toggle(this.burger_class)
    }

    toggleMobileMenuClass() {
        this.mobile_menu.classList.toggle(this.active_class)
    }

    getHeaderHeight() {
        return `${this.header.offsetHeight}px`
    }

    // Function to set the mobile menu max-height, combined with the header offset.
    setMobileMenuHeight() {
        this.mobile_menu.style.maxHeight = `calc(100vh - ${this.getHeaderHeight()})`
    }

    // Function to reset mobile menu and tertiary menus to first loaded state
    resetTertiaryMenus() {
        const elements_with_tertiary_target = this.mobile_menu.querySelectorAll('[data-mobile-tertiary-target]')

        elements_with_tertiary_target.forEach(el => {
            const tertiary_target = document.querySelector(el.dataset.mobileTertiaryTarget)

            if (tertiary_target) {
                tertiary_target.classList.remove(this.active_class)
            }
        })

        this.mobile_menu.classList.remove(this.active_tertiary_menu_class)
    }
}

new mobileMenu()